import SelectorCountry from './selectorCountry';

export default SelectorCountry;